import React from 'react'
import keyBy from 'lodash/keyBy'
import {
  TextField,
  useQuery,
  Datagrid,
  Pagination,
  ListContextProvider,
  FunctionField,
} from 'react-admin'
import { formatGender, formatSportKind } from '../../utils/format'
import { usePagination } from '../../../hooks'

export const ParticipantsList = (props) => {
  const { page, perPage, setPage, setPerPage } = usePagination()
  const currentClubId = props.record.id
  const { data, total } = useQuery({
    type: 'getList',
    resource: `clubs/${currentClubId}/users`,
    payload: {
      pagination: { page, perPage },
      sort: { field: 'id', order: 'ASC' },
    },
  })
  return (
    <ListContextProvider
      value={{
        resource: 'users',
        basePath: '/clubs',
        data: keyBy(data, 'id'),
        ids: data?.map((el) => el.id),
        currentSort: { field: 'id', order: 'ASC' },
        selectedIds: [],
      }}
    >
      <Datagrid rowClick=''>
        <TextField source='fullName' label='Имя' />
        <FunctionField
          label='Пол'
          render={(record) => formatGender(record.gender)}
        />
        <TextField source='email' label='E-mail' emptyText='Не указано' />
        <TextField source='phone' label='Телефон' emptyText='Не указано' />
        <TextField source='city.name' label='Город' emptyText='Не указано' />
        <FunctionField
          label='Вид спорта'
          render={(record) => formatSportKind(record.sportKind)}
        />
      </Datagrid>
      <Pagination
        page={page}
        perPage={perPage}
        setPage={setPage}
        total={total}
        setPerPage={setPerPage}
      />
    </ListContextProvider>
  )
}
